import { render, staticRenderFns } from "./Intro_panel.vue?vue&type=template&id=3b4837d0&scoped=true&"
import script from "./Intro_panel.vue?vue&type=script&lang=js&"
export * from "./Intro_panel.vue?vue&type=script&lang=js&"
import style0 from "./Intro_panel.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./Intro_panel.vue?vue&type=style&index=1&id=3b4837d0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4837d0",
  null
  
)

component.options.__file = "Intro_panel.vue"
export default component.exports